import type { LinkedTableJoinConditionApi } from '@loader/shared-types';

import type { FieldMapping } from '@/lib/types';

/**
 * Check if a field mapping is complete (has both sides filled in).
 * For formula mode: both source and target formulas must be non-empty.
 * For field mode: both source and target field IDs must be set.
 */
export function isFieldMappingComplete(mapping: FieldMapping): boolean {
  return mapping.mode === 'formula'
    ? !!(mapping.source_formula?.trim() && mapping.target_formula?.trim())
    : !!(mapping.source_field_id && mapping.target_field_id);
}

/**
 * Convert frontend FieldMapping to API join condition format.
 * Handles both field-based and formula-based mappings.
 */
export function mapFieldMappingToCondition(mapping: FieldMapping): LinkedTableJoinConditionApi {
  if (mapping.mode === 'formula') {
    return {
      left_formula: mapping.source_formula || '',
      operator: '=' as const,
      right_formula: mapping.target_formula || '',
    };
  }
  return {
    left_field: mapping.source_field_id,
    operator: '=' as const,
    right_field: mapping.target_field_id,
  };
}
